import { DepTables, EditStore, EditStoreProps } from '@/main/store/@types/edit.d';
import { DEPENDENT_TABLES_ALL as depTableNames } from '@/modules/servis/zakazka/nahradniDily/constants';

import { dropdownList, edit, localState } from './state';

type State = EditStore<typeof edit, typeof dropdownList, typeof localState, DepTables<typeof depTableNames>, EditStoreProps>;

type Data<T = {}> = { data: any & T };

export const mutations = <const>{
};
